$('.field input.opensearch').click(function(){
    $('.searchSub').fadeIn();
  })
  $('#Search-In-Modal').bind('input propertychange', function() {
      var screenWidth = $(window).width();
    if(screenWidth>990){
          var valLength = $(this).val().length;
          if(valLength>0){
             $('.searchSub').fadeOut();
          }else{
             $('.searchSub').fadeIn();
          }
      }else{
          
      }
          
  }); 
  $('.wap_search .search__input').bind('input propertychange', function() {
      var screenWidth = $(window).width();
      if(screenWidth>990){
        
      }else{
          var valLength = $(this).val().length;
        
          if(valLength>0){
             $('.quickSearch').hide();
          }else{
             $('.quickSearch').fadeIn();
          }
      }
          
  }); 
  $('.searchSub,.search-modal__content-bottom').click(function(e){
          e.stopPropagation();
  })
  $('body').click(function(){
          $('.searchSub').fadeOut();
  })
  

  $('.mobSearch').click(function(e){
    e.stopPropagation();
    $('.searchSub').fadeToggle();
  })